module.exports = __webpack_public_path__ + "media/src/public/img/saveme_qr_tinkoff-b945f442c857f77058616f481460c39e.png";